/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiScenarioTypology
 */
export interface InternalApiScenarioTypology {
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioTypology
     */
    id: string;
    /**
     * Scenario typology name
     * @type {string}
     * @memberof InternalApiScenarioTypology
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioTypology
     */
    categoryId: string;
}

/**
 * Check if a given object implements the InternalApiScenarioTypology interface.
 */
export function instanceOfInternalApiScenarioTypology(value: object): value is InternalApiScenarioTypology {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('categoryId' in value) || value['categoryId'] === undefined) return false;
    return true;
}

export function InternalApiScenarioTypologyFromJSON(json: any): InternalApiScenarioTypology {
    return InternalApiScenarioTypologyFromJSONTyped(json, false);
}

export function InternalApiScenarioTypologyFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioTypology {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'categoryId': json['categoryId'],
    };
}

export function InternalApiScenarioTypologyToJSON(json: any): InternalApiScenarioTypology {
    return InternalApiScenarioTypologyToJSONTyped(json, false);
}

export function InternalApiScenarioTypologyToJSONTyped(value?: InternalApiScenarioTypology | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'categoryId': value['categoryId'],
    };
}

